import React from 'react';
import Images from '../ImagesComponent/Images.js';

class ThumbnailMitraDetail extends React.Component {
    render() {
        const { cover, startdate, url } = this.props
        return (
            <div className="itemcontainer" >
                <a href={url.toLowerCase().replace(/ /g,'-')}>
                    <Images alt="" src={cover} className="mainimage" style={{maxHeight:'220px'}}/>
                    {
                        startdate &&
                        startdate.indexOf('Sekarang') > -1 &&
                        <div className="itemdetail" id="itemdetails">
                            <h5>{startdate}</h5>
                            <span>Kelas dan Materi</span>
                            <a href={url} className="fammibutton2">Lihat</a>
                        </div>
                    }
                    {
                        startdate &&
                        startdate.indexOf('Sekarang') < 0 &&
                        <div className="itemdetail" id="itemdetails">
                            <h5>Kelas dimulai</h5>
                            <span>{startdate}</span>
                            <a href={url} className="fammibutton2">Lihat</a>
                        </div>
                    }
                </a>
            </div>
        )
    }
}

export default ThumbnailMitraDetail